import { Suspense, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { EuiProgress } from "@elastic/eui";
import { globalFilterSelector } from "reduxStore/globalFilter/globalFilter.selectors";
import Clients from "services/ClientService/Clients";
import Layout from "../layout/Layout/Layout";
import DashboardLoader from "components/Loader/DashboardLoader";
import { COLORS } from "Consts";

const PrivateRouteContainer = () => {
  const { clientInfo } = useSelector(globalFilterSelector, shallowEqual);

  useEffect(() => {
    if (!clientInfo.clientID) {
      Clients.loadLastAccessedClient();
    }
  }, [JSON.stringify(clientInfo)]);

  if (!clientInfo?.clientID) {
    return <EuiProgress color={COLORS.$progressGreen} size="xs" />;
  }

  return (
    <Layout>
      <Suspense fallback={<DashboardLoader />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

export default PrivateRouteContainer;
